import { path } from 'ramda'

import { isAbortError } from '@common/utils'

const REDLINE_PDF_EXPORT_LOADING = 'REDLINE_PDF_EXPORT_LOADING'
const REDLINE_PDF_EXPORT_LOADED = 'REDLINE_PDF_EXPORT_LOADED'
const REDLINE_PDF_EXPORT_FAILED = 'REDLINE_PDF_EXPORT_FAILED'

const NOISE_PDF_EXPORT_LOADING = 'NOISE_PDF_EXPORT_LOADING'
const NOISE_PDF_EXPORT_LOADED = 'NOISE_PDF_EXPORT_LOADED'
const NOISE_PDF_EXPORT_FAILED = 'NOISE_PDF_EXPORT_FAILED'

const DATA_QUALITY_PDF_EXPORT_LOADING = 'DATA_QUALITY_PDF_EXPORT_LOADING'
const DATA_QUALITY_PDF_EXPORT_LOADED = 'DATA_QUALITY_PDF_EXPORT_LOADED'
const DATA_QUALITY_PDF_EXPORT_FAILED = 'DATA_QUALITY_PDF_EXPORT_FAILED'

const defaultState = {}

const entityName = 'reportExport'

export const GENERIC_PDF_EXPORT_ERROR = 'Unable to generate PDF. Something went wrong.'

export default {
  name: entityName,
  reducer: (state, action) => {
    if (action.type === REDLINE_PDF_EXPORT_LOADING) {
      return { ...state, redline: { ...action.meta, payload: action.payload } }
    }
    if (action.type === REDLINE_PDF_EXPORT_LOADED) {
      return { ...state, redline: { ...action.meta, data: action.payload } }
    }
    if (action.type === REDLINE_PDF_EXPORT_FAILED) {
      return { ...state, redline: { ...action.meta, error: action.payload } }
    }
    if (action.type === NOISE_PDF_EXPORT_LOADING) {
      return { ...state, noise: { ...action.meta, payload: action.payload } }
    }
    if (action.type === NOISE_PDF_EXPORT_LOADED) {
      return { ...state, noise: { ...action.meta, data: action.payload } }
    }
    if (action.type === NOISE_PDF_EXPORT_FAILED) {
      return { ...state, noise: { ...action.meta, error: action.payload } }
    }
    if (action.type === DATA_QUALITY_PDF_EXPORT_LOADING) {
      return { ...state, dataQuality: { ...action.meta, payload: action.payload } }
    }
    if (action.type === DATA_QUALITY_PDF_EXPORT_LOADED) {
      return { ...state, dataQuality: { ...action.meta, data: action.payload } }
    }
    if (action.type === DATA_QUALITY_PDF_EXPORT_FAILED) {
      return { ...state, dataQuality: { ...action.meta, error: action.payload } }
    }
    return state || defaultState
  },
  selectRedlineReportExportIsLoading: ({ reportExport }) => {
    const status = path(['redline', 'status'], reportExport)
    return status === 'loading'
  },
  selectNoiseReportExportIsLoading: ({ reportExport }) => {
    const status = path(['noise', 'status'], reportExport)
    return status === 'loading'
  },
  selectDataQualityReportExportIsLoading: ({ reportExport }) => {
    const status = path(['dataQuality', 'status'], reportExport)
    return status === 'loading'
  },
  doExportRedlineReport:
    (eventId) =>
    async ({ dispatch, apiFetch }) => {
      try {
        dispatch({
          type: REDLINE_PDF_EXPORT_LOADING,
          payload: null,
          meta: { status: 'loading' },
        })

        const response = await apiFetch(
          `/events/${eventId}/red_line_report_pdf/`,
          {},
          {
            method: 'GET',
            cancelationPrefix: `${entityName}_redline`,
            download: true,
          },
        )
        if (!response) throw new Error(GENERIC_PDF_EXPORT_ERROR)

        dispatch({
          type: REDLINE_PDF_EXPORT_LOADED,
          payload: response,
          meta: { status: 'succeeded' },
        })
        return response
      } catch (err) {
        if (!isAbortError(err)) {
          dispatch({
            type: REDLINE_PDF_EXPORT_FAILED,
            payload: err,
            meta: { status: 'failed' },
          })
          throw err
        }
        return null
      }
    },
  doExportNoiseReport:
    (eventId) =>
    async ({ dispatch, apiFetch }) => {
      try {
        dispatch({
          type: NOISE_PDF_EXPORT_LOADING,
          payload: null,
          meta: { status: 'loading' },
        })

        const response = await apiFetch(
          `/events/${eventId}/noise_report_pdf/`,
          {},
          {
            method: 'GET',
            cancelationPrefix: `${entityName}_noise`,
            download: true,
          },
        )
        if (!response) throw new Error(GENERIC_PDF_EXPORT_ERROR)

        dispatch({
          type: NOISE_PDF_EXPORT_LOADED,
          payload: response,
          meta: { status: 'succeeded' },
        })
        return response
      } catch (err) {
        if (!isAbortError(err)) {
          dispatch({
            type: NOISE_PDF_EXPORT_FAILED,
            payload: err,
            meta: { status: 'failed' },
          })
          throw err
        }
        return null
      }
    },
  doExportDataQualityReport:
    (eventId) =>
    async ({ dispatch, apiFetch }) => {
      try {
        dispatch({
          type: DATA_QUALITY_PDF_EXPORT_LOADING,
          payload: null,
          meta: { status: 'loading' },
        })

        const response = await apiFetch(
          `/events/${eventId}/data_quality_report_pdf/`,
          {},
          {
            method: 'GET',
            cancelationPrefix: `${entityName}_data_quality`,
            download: true,
          },
        )
        if (!response) throw new Error(GENERIC_PDF_EXPORT_ERROR)

        dispatch({
          type: DATA_QUALITY_PDF_EXPORT_LOADED,
          payload: response,
          meta: { status: 'succeeded' },
        })
        return response
      } catch (err) {
        if (!isAbortError(err)) {
          dispatch({
            type: DATA_QUALITY_PDF_EXPORT_FAILED,
            payload: err,
            meta: { status: 'failed' },
          })
          throw err
        }
        return null
      }
    },
}
